module.exports = __webpack_public_path__ + "img/user-gravatar.2ae22172.svg";